import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Spin from '../Spin';
import filter from './filter';
import SCard from '../Card';
import Checkbox from '../Checkbox';
import { PureComponent } from '../component';
import { transferClass } from './styles';
import { getKey } from '../utils/uid';
import { createFunc } from '../utils/func';
import { isFunc } from '../utils/is';
import Item from './item';
import LazyList from '../AnimationList/LazyList';
import { getLocale } from '../locale';
import Input from '../Input';

var Card =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Card, _PureComponent);

  var _super = _createSuper2(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    _this = _super.call(this, props);
    _this.cardBody = void 0;
    _this.getCheckAll = _this.getCheckAll.bind(_assertThisInitialized(_this));
    _this.checkAll = _this.checkAll.bind(_assertThisInitialized(_this));
    _this.handleRenderItem = _this.handleRenderItem.bind(_assertThisInitialized(_this));
    _this.bindCardBody = _this.bindCardBody.bind(_assertThisInitialized(_this));
    _this.customSetSelected = _this.customSetSelected.bind(_assertThisInitialized(_this));
    _this.state = {
      listHeight: props.listHeight,
      mounted: false
    };
    return _this;
  }

  _createClass(Card, [{
    key: "getCheckAll",
    value: function getCheckAll() {
      var _this$props = this.props,
          selecteds = _this$props.selecteds,
          data = _this$props.data;
      if (selecteds.length === 0) return false;
      if (selecteds.length === data.length) return true;
      return 'indeterminate';
    }
  }, {
    key: "bindCardBody",
    value: function bindCardBody(node) {
      this.cardBody = node;
      var listHeight = this.props.listHeight;

      if (node) {
        listHeight = node.offsetHeight;
      }

      this.setState({
        listHeight: listHeight,
        mounted: true
      });
    }
  }, {
    key: "checkAll",
    value: function checkAll(c) {
      var _this$props2 = this.props,
          setSelecteds = _this$props2.setSelecteds,
          index = _this$props2.index,
          data = _this$props2.data,
          keygen = _this$props2.keygen,
          disabled = _this$props2.disabled;

      if (c) {
        if (typeof disabled === 'function') setSelecteds(index, data.reduce(function (r, d, i) {
          if (disabled(d)) return r;
          r.push(getKey(d, keygen, i));
          return r;
        }, []));else setSelecteds(index, data.map(function (d, i) {
          return getKey(d, keygen, i);
        }));
      } else {
        setSelecteds(index, []);
      }
    }
  }, {
    key: "handleRenderItem",
    value: function handleRenderItem(d, i) {
      var _this$props3 = this.props,
          keygen = _this$props3.keygen,
          index = _this$props3.index,
          renderItem = _this$props3.renderItem,
          disabled = _this$props3.disabled,
          lineHeight = _this$props3.lineHeight;
      var disable = disabled === true;
      var key = getKey(d, keygen, i);
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          lineHeight: lineHeight,
          key: key,
          disabled: disable || typeof disabled === 'function' && disabled(d),
          index: index,
          checkKey: key,
          liData: d,
          content: createFunc(renderItem)(d)
        })
      );
    }
  }, {
    key: "customSetSelected",
    value: function customSetSelected(value) {
      var _this$props4 = this.props,
          index = _this$props4.index,
          setSelecteds = _this$props4.setSelecteds,
          selecteds = _this$props4.selecteds;

      if (typeof value === 'string' || typeof value === 'number') {
        setSelecteds(index, [].concat(_toConsumableArray(selecteds), [value]));
        return;
      }

      if (Array.isArray(value)) {
        setSelecteds(index, value);
      }
    }
  }, {
    key: "renderLazyList",
    value: function renderLazyList() {
      var _this$props5 = this.props,
          filterText = _this$props5.filterText,
          data = _this$props5.data,
          rowsInView = _this$props5.rowsInView,
          lineHeight = _this$props5.lineHeight,
          keygen = _this$props5.keygen;
      var _this$state = this.state,
          mounted = _this$state.mounted,
          listHeight = _this$state.listHeight;
      if (!mounted) return null;
      return (
        /*#__PURE__*/
        React.createElement(LazyList, {
          stay: !filterText,
          data: data,
          itemsInView: rowsInView,
          lineHeight: lineHeight,
          height: listHeight,
          keygen: keygen // scrollHeight={lineHeight * data.length}
          ,
          renderItem: this.handleRenderItem
        })
      );
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props6 = this.props,
          customRender = _this$props6.customRender,
          index = _this$props6.index,
          values = _this$props6.values,
          filterText = _this$props6.filterText;

      if (isFunc(customRender)) {
        var custom = customRender({
          onSelected: this.customSetSelected,
          direction: index === 0 ? 'left' : 'right',
          selectedKeys: this.props.selecteds,
          value: values,
          filterText: filterText
        });
        if (custom) return custom;
      }

      return this.renderLazyList();
    }
  }, {
    key: "renderFilter",
    value: function renderFilter() {
      var _this$props7 = this.props,
          onFilter = _this$props7.onFilter,
          onSearch = _this$props7.onSearch,
          renderFilter = _this$props7.renderFilter,
          filterText = _this$props7.filterText,
          disabled = _this$props7.disabled,
          index = _this$props7.index;
      if (!onFilter && !onSearch) return null;

      if (renderFilter && typeof renderFilter === 'function') {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: transferClass('filter')
          }, renderFilter({
            value: filterText,
            disabled: disabled === true,
            onFilter: onFilter,
            placeholder: getLocale('search'),
            isSource: index === 0
          }))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('filter')
        },
        /*#__PURE__*/
        React.createElement(Input, {
          disabled: disabled === true,
          onChange: onFilter,
          placeholder: getLocale('search'),
          clearable: true,
          value: filterText
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          title = _this$props8.title,
          data = _this$props8.data,
          selecteds = _this$props8.selecteds,
          footer = _this$props8.footer,
          listClassName = _this$props8.listClassName,
          listStyle = _this$props8.listStyle,
          empty = _this$props8.empty,
          disabled = _this$props8.disabled,
          loading = _this$props8.loading,
          listHeight = _this$props8.listHeight,
          customRender = _this$props8.customRender;
      var check = this.getCheckAll();
      var disable = disabled === true;
      var listms = Object.assign({}, listStyle, {
        height: listHeight
      });
      return (
        /*#__PURE__*/
        React.createElement(SCard, {
          className: transferClass('card')
        },
        /*#__PURE__*/
        React.createElement(SCard.Header, {
          className: transferClass('card-header')
        },
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(Checkbox, {
          onChange: this.checkAll,
          checked: check,
          disabled: disable
        }, check ? "".concat(selecteds.length, " ").concat(getLocale('selected')) : getLocale('selectAll'))),
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('card-header-title')
        }, title)), this.renderFilter(),
        /*#__PURE__*/
        React.createElement(Spin, {
          loading: loading
        },
        /*#__PURE__*/
        React.createElement(SCard.Body, {
          className: classnames(transferClass('card-body'), listClassName),
          style: listms
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('body-container'),
          ref: this.bindCardBody
        }, this.renderBody(), !isFunc(customRender) && data.length === 0 &&
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('empty')
        }, empty || getLocale('noData'))))), footer &&
        /*#__PURE__*/
        React.createElement(SCard.Footer, {
          className: transferClass('card-footer')
        }, footer))
      );
    }
  }]);

  return Card;
}(PureComponent);

export default filter(Card);